// Close Minimog cart drawer on Escape
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;

  const container = document.querySelector('#cart-drawer-container');
  if (!container) return;

  // If nothing is rendered in the container, drawer isn't open
  if (!container.querySelector('*')) return;

  // Try the close button inside the drawer
  const closeBtn =
    container.querySelector('[data-drawer-close]') ||
    container.querySelector('[data-cart-drawer-close]') ||
    container.querySelector('button[aria-label="Close"]') ||
    container.querySelector('.drawer__close') ||
    container.querySelector('.m-drawer__close') ||
    container.querySelector('button');

  if (closeBtn) {
    closeBtn.click();
    event.preventDefault();
    return;
  }

  // Fallback, click overlay if present
  const overlay =
    document.querySelector('.drawer-overlay') ||
    document.querySelector('.m-drawer__overlay') ||
    document.querySelector('.overlay');

  if (overlay) {
    overlay.click();
    event.preventDefault();
  }
});
